/**
 * Volume-aware contextual prompts
 * These replace simple count-based prompts with contextual guidance.
 */

export type VolumeLevel = 'low' | 'medium' | 'high';

export interface VolumeContext {
  projectContext: string;
  scopeGuidance: string;
  granularityHint: string;
}

export const VOLUME_CONTEXTS: Record<VolumeLevel, VolumeContext> = {
  low: {
    projectContext: 'This is a small, focused initiative or proof-of-concept.',
    scopeGuidance: 'Keep the scope lean and manageable. Focus on core functionality only.',
    granularityHint: 'Each item should represent a meaningful chunk of work. Avoid over-decomposition.'
  },
  medium: {
    projectContext: 'This is a standard project with typical complexity.',
    scopeGuidance: 'Provide balanced coverage of the requirements with appropriate detail.',
    granularityHint: 'Break down work into well-sized items that a team can estimate and deliver in a sprint.'
  },
  high: {
    projectContext: 'This is a large enterprise initiative requiring comprehensive planning.',
    scopeGuidance:
      'Provide extensive coverage with detailed breakdown. Consider edge cases, integrations, and non-functional requirements.',
    granularityHint:
      'Create granular, well-defined items. Include supporting work like documentation, testing, and deployment considerations.'
  }
};
